import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {DealCardComponent} from './deal-card/deal-card.component';
import {TagModule} from 'primeng/tag';
import {BadgeModule} from 'primeng/badge';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {ResponsiveImageDirective} from './responsive-image-directive/responsive-image.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {InputTextModule} from 'primeng/inputtext';
import {InputNumberModule} from 'primeng/inputnumber';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {SliderModule} from 'primeng/slider';
import {RouterLink} from '@angular/router';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ViatorCardComponent} from './viator-card/viator-card.component';
import {SearchSelectComponent} from './search-select-form/search-select-form.component';
import {PlanPricingDurationPipe} from '../../helpers/pipes/plan-pricing-duration.pipe';
import {PlanCardButtonTextPipe} from '../../helpers/pipes/plan-card-button-text.pipe';
import {ExperienceDurationPipe} from '../../helpers/pipes/experience-duration.pipe';
import {DealActivateDirective} from '../../helpers/directives/deal-activate.directive';
import {FlightClassLabelPipe} from '../../helpers/pipes/flight-class-label.pipe';
import {CardModule} from 'primeng/card';
import { ShareLinkPillComponent } from './share-link-pill/share-link-pill.component';
import { ItineraryCalendarComponent } from './itinerary-calendar/itinerary-calendar.component';
import {PageHeroComponent} from './page-hero/page-hero.component';


@NgModule({
    declarations: [
        DealCardComponent,
        ViatorCardComponent,
        SearchSelectComponent,
        PlanPricingDurationPipe,
        PlanCardButtonTextPipe,
        ExperienceDurationPipe,
        DealActivateDirective,
        FlightClassLabelPipe,
        ShareLinkPillComponent,
        ItineraryCalendarComponent,
        PageHeroComponent,
    ],
    imports: [
        CommonModule,
        TagModule,
        BadgeModule,
        ButtonModule,
        DialogModule,
        ReactiveFormsModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        InputNumberModule,
        OverlayPanelModule,
        SliderModule,
        FormsModule,
        RouterLink,
        CardModule,
        ResponsiveImageDirective,
        NgOptimizedImage,
        DialogModule,
        ResponsiveImageDirective,
        ProgressSpinnerModule,
    ],
    exports: [
        DealCardComponent,
        ViatorCardComponent,
        ResponsiveImageDirective,
        SearchSelectComponent,
        ResponsiveImageDirective,
        PlanPricingDurationPipe,
        PlanCardButtonTextPipe,
        ExperienceDurationPipe,
        DealActivateDirective,
        FlightClassLabelPipe,
        ShareLinkPillComponent,
        ItineraryCalendarComponent,
        PageHeroComponent,
    ]
})
export class SharedModule {
}
